<template>
  <admin-wrapper title-translation-path="admin.dictionariesSettings" :has-buttons="false" :inputs="inputs">
    <template #dictionaries.input>
      <v-row no-gutters>
        <v-col cols="8">
          <grey-tabs v-model="tab" :tabs="tabItems" cols="auto" has-border>
            <v-tab-item v-for="item in tabItems" :key="item.name">
              <component :is="item.component" class="mt-8"></component>
            </v-tab-item>
          </grey-tabs>
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import DictionariesSettingsList from '@/components/DictionariesSettingsList';
import GreyTabs from '@/components/GreyTabs';
import DynamicDictionariesSettingsList from '@/components/DynamicDictionariesSettingsList';

export default {
  name: 'DictionariesSettings',
  components: {
    AdminWrapper,
    GreyTabs,
    DictionariesSettingsList,
    DynamicDictionariesSettingsList,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    tabItems() {
      return [
        {
          name: this.$i18n.t('admin.simpleDictionariesTab'),
          component: 'DictionariesSettingsList',
        },
        {
          name: this.$i18n.t('admin.dynamicDictionariesTab'),
          component: 'DynamicDictionariesSettingsList',
        },
      ];
    },
    inputs() {
      return [
        {
          name: 'dictionaries',
          isNamedSlot: false,
        },
      ];
    },
  },
};
</script>
